import { __assign } from "tslib";
import { isAppListedAsBundle, isNewVersionAvailable, isPendingApp, isSetupIncomplete } from './appUtils';
import { ModalNames } from '../components/modals/modals';
import { getScaleToFillImageURL } from 'image-client-api/dist/imageClientSDK';
export var enrichBundleApps = function (bundleApps, installedApps) {
    return bundleApps
        ? Array.from(bundleApps, function (app) { return enrichBundleApp(app, installedApps); })
        : [];
};
var enrichBundleApp = function (bundleApp, installedApps) {
    if (bundleApp === null || bundleApp === void 0 ? void 0 : bundleApp.upgradeSuggestion) {
        //app is installed
        var installedApp = installedApps.find(function (app) { return app.webSolutionBase.id === bundleApp.webSolutionBase.id; });
        var enrichedBundleApp = __assign(__assign({}, bundleApp), { supportEmails: installedApp.supportEmails, components: installedApp.components, isUpgraded: installedApp.isUpgraded, premiumAutoRenew: installedApp.premiumAutoRenew, instanceId: installedApp.instanceId });
        return enrichedBundleApp;
    }
    return bundleApp;
};
export var getAppsRequiredPremium = function (siteIsPremium, installedApps) {
    return siteIsPremium
        ? []
        : installedApps.filter(function (app) {
            return app.webSolutionBase.pricing &&
                app.webSolutionBase.pricing.isRequiredWixPremium &&
                app.eligibleForUpgrade;
        });
};
export var getCompleteSetupApps = function (installedApps, bundleApps, siteIsPremium, experiments) {
    if (!installedApps) {
        return;
    }
    var pendingApps = experiments.enabled('specs.marketplace.complete-setup') ? installedApps.filter(function (app) { return !isAppListedAsBundle(app, bundleApps) && isPendingApp(app) && !isNewVersionAvailable(app, experiments); }) : installedApps.filter(function (app) { return !isAppListedAsBundle(app, bundleApps) && isPendingApp(app); });
    var appsWithNewVersionAvailable = installedApps.filter(function (app) { return !isAppListedAsBundle(app, bundleApps) && isNewVersionAvailable(app, experiments); });
    var setupIncompleteApps = installedApps.filter(function (app) { return !isNewVersionAvailable(app, experiments) && !isAppListedAsBundle(app, bundleApps) && isSetupIncomplete(app, experiments); });
    if (experiments.enabled('specs.marketplace.complete-setup')) {
        return (pendingApps
            // @ts-ignore
            .concat(setupIncompleteApps)
            .concat(appsWithNewVersionAvailable)
            .concat(getAppsRequiredPremium(siteIsPremium, installedApps))
            .concat(bundleApps)
            .filter(function (x, i, a) { return a.indexOf(x) === i; }));
    }
    return (appsWithNewVersionAvailable
        .concat(pendingApps)
        // @ts-ignore
        .concat(bundleApps)
        .concat(getAppsRequiredPremium(siteIsPremium, installedApps))
        .filter(function (x, i, a) { return a.indexOf(x) === i; }));
};
export var getDeepLink = function (deepLinkData, installedApps) {
    if (deepLinkData && deepLinkData.modal === 'delete' && deepLinkData.appId) {
        var installedApp = installedApps.find(function (app) { return app.webSolutionBase.id === deepLinkData.appId; });
        if (installedApp) {
            return {
                openModal: ModalNames.DELETE,
                modalProps: {
                    openModalName: ModalNames.DELETE,
                    app: installedApp,
                },
            };
        }
    }
    return {};
};
export var filterDismissedBundleApps = function (apps) {
    return apps
        ? apps.filter(function (app) {
            var localStorageData = localStorage.getItem("dismissed-" + app.webSolutionBase.id);
            return localStorageData !== 'dismissed';
        })
        : [];
};
export var businessSolutionAppsToFilter = [
    '1380b703-ce81-ff05-f115-39571d94dfcd',
    '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
    '140603ad-af8d-84a5-2c80-a0f60cb47351',
    '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
    '14bcded7-0066-7c35-14d7-466cb3f09103',
    '14724f35-6794-cd1a-0244-25fd138f9242',
    '13e8d036-5516-6104-b456-c8466db39542',
    '148c2287-c669-d849-d153-463c7486a694',
    '14ce1214-b278-a7e4-1373-00cebd1bef7c',
    '2936472a-a1ed-4ae5-9f71-614313a9f4e7',
    '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9',
    '13ff8629-c1fc-e289-e81f-bc8c8968e9d6',
    '14409595-f076-4753-8303-9a86f9f71469',
    '14517e1a-3ff0-af98-408e-2bd6953c36a2',
    '1484cb44-49cd-5b39-9681-75188ab429de',
    '215238eb-22a5-4c36-9e7b-e7c08025e04e',
];
export var filterBusinessSolutionApps = function (installedApps) {
    if (installedApps === void 0) { installedApps = []; }
    return installedApps.filter(function (app) { return !businessSolutionAppsToFilter.includes(app.webSolutionBase.id); });
};
var getURI = function (iconURL) { return iconURL && iconURL.split('/').pop(); };
export var getClientImageURL = function (iconURL, options) {
    var originalWidth = options.originalWidth, originalHeight = options.originalHeight, toWidth = options.toWidth, toHeight = options.toHeight;
    return getScaleToFillImageURL(getURI(iconURL), originalWidth, originalHeight, toWidth, toHeight);
};
//# sourceMappingURL=utils.js.map